import $http from '../../axios-instance';
import Swal from 'sweetalert2';


export async function listarPlaneacionAuditoria({state, commit}, requestParameters = {params: state.filtro}) {

    commit('dashboard/load', true, {root: true});

    if (state.filtro.id_empresa) {
        await $http.get('empresas/planeacion-auditoria', requestParameters)
            .then((response) => {
                commit('setListasPlaneacion', response.data.data);
            }).catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
                commit('accionError', error.message);
            });
    }

    commit('dashboard/load', false, {root: true});
}

/**
 * Método para obtener todas las planeaciones acordes a la búsqueda realizada
 *
 * @param {*} requestParams contiene el id de la empresa y el id de la lista de chequeo
 * @author Santiago Echeverri
 */
export async function getPlaneacion({commit, state}) {
    await $http.get('empresas/planeacion-auditoria', {params: state.filtro})
        .then((response) => {
            commit('setListasPlaneacionHallazgos', response.data.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit('accionError', error.message);
        });
}

/**
 *
 */
export async function crearPlaneacion({commit, state, dispatch}) {

    commit('dashboard/load', true, {root: true});

    return await new Promise(async (resolve, reject) => {

        commit('cargaHallazgos', state.listaTipoSeguimientos);

        await $http.post('adm_empresas/planeacion/crear', state.selectedPlaneacion)
            .then(
                async (response) => {

                    commit('setPlaneacion', response.data.planeacion);

                    commit('dashboard/load', false, {root: true});

                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000
                    });

                    resolve();
                })
            .catch(
                async (error) => {
                    commit('dashboard/load', false, {root: true});

                    await Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 5000
                    });

                    reject();
                });
    });
}

export async function actualizarPlaneacion({ commit, state}) {

    commit('dashboard/load', true, {root: true});
    commit('setAuditPlanning', state.listaTipoSeguimientos);

    await $http.put(`empresas/planeacion/editar/${state.selectedPlaneacion.id}`, state.selectedPlaneacion)
        .then((response) => {
        
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 3000
            });
            commit('setPlaneacionId', response.data.id);
        })
        .catch(async (error) => {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

export async function mostrarPlaneacionAuditoria({commit, state}, {id_planeacion, id_empresa}) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`empresas/planeacion-auditoria/mostrar/${id_planeacion}/${id_empresa}`)
        .then((response) => {
            commit('setPlaneacion', response.data.data);
            commit('establecerEmpresas', [response.data.data.empresa]);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
    commit('dashboard/load', false, {root: true});
}


export async function crearPlaneacionAuditoria({commit, state}) {
    await $http.post(`adm_empresas/planeacion-auditoria/crear/${state.selectedPlaneacion.id_empresa}`, {planeacion_auditoria: state.hallazgoArr})
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            state.id = response.data.id;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function actualizarPlaneacionAuditoria({commit, state, dispatch}) {
    $http.put(`empresas/planeacion-auditoria/editar/${state.selectedListaChequeo.id}`, state.selectedListaChequeo)
        .then((response) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });

            dispatch('mostrarPlaneacionAuditoria', state.selectedListaChequeo.id);
            state.error = false;
        }).catch((error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 5000
        });
        commit('accionError', error.message);
    });
}

/**
 * Método para obtener todas el empresas registradas en el sistema.
 *
 * @param {*} param0
 * @param {*} query contiene parametros del proceso.
 */
export async function getEmpresaFiltro({commit, state}) {


    if (state.empresas.length == 0) {
        await $http.get('/empresas/lista')
            .then((response) => {
                commit('setListaEmpresa', response.data);
                state.error = false;
            })
            .catch((error) => {
                commit('mensajeError', error.message);
            });
    }
}

/**
 * Obtener empresas
 */
export async function obtenerEmpresas({dispatch, commit, state}, nombre) {
    dispatch('obtenerEmpresasPeticion', nombre)
        .then(empresas => commit('establecerEmpresas', empresas));
}

/**
 * Obtener empresas filtro
 */
export async function obtenerEmpresasFiltro({commit, dispatch}, nombre) {
    dispatch('obtenerEmpresasPeticion', nombre)
        .then(empresas => commit('establecerEmpresasFiltro', empresas));

}

/**
 * Obtener empresas desde el back
 */
export async function obtenerEmpresasPeticion({commit, state}, nombre) {

    return await new Promise(async (resolve, reject) => {
        if (!state.cargando_datos_select && nombre && nombre.length > 1) {
            commit('establecerCargandoDatosSelect', true);

            let parametros = {
                params: {
                    nombre: nombre
                }
            };

            await $http.get('/empresas/lista', parametros)
                .then((response) => {
                    resolve(response.data.data);
                    commit('establecerCargandoDatosSelect', false);
                })
                .catch(() => {
                    console.warn('No se encontraron empresas con el nombre especificado');
                    reject([]);
                    commit('establecerCargandoDatosSelect', false);
                });
        }
    });
}


export async function listarTipoSeg({state, commit}) {

    commit('dashboard/load', true, {root: true});

    const parametros = {
        params: {
            id_tipo_lista_chequeo: state.selectedPlaneacion.id_tipo_lista_chequeo
        }
    };

    await $http.get('adm_general/lista-tipo-seguimiento', parametros)
        .then((response) => {
            commit('setMostrarTipoSeguimiento', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

//Registro

export async function listarRegistroAuditoria({state, commit}, params) {

    if (params.id_planeacion_auditoria) {

        commit('dashboard/load', true, {root: true});

        const parametros = {
            params: params
        };

        await $http.get('empresas/registros', parametros)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setListaRegistros', response.data.data);
            }).catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                });
                commit('accionError', error.message);
            });
    }
}

export async function guardaRegistro({state, commit}, data) {

    commit('dashboard/load', true, {root: true});

    await $http.post('empresas/registros-auditoria/crear', data, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

export async function getRegistro({state, commit}, registro) {

    commit('dashboard/load', true, {root: true});
    const parametros = {
        id_empresa: state.selectedPlaneacion.id_empresa,
        id_planeacion: registro.id_planeacion
    };

    let nombre = registro.registro;

    await $http({
        url: 'empresas/registros-auditoria/mostrar/' + registro.id,
        method: 'GET',
        responseType: 'blob',
        params: parametros
    }).then((response) => {
        window.downloadFile(response.data, nombre)
    }).catch((error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 5000
        });
    });
    commit('dashboard/load', false, {root: true});
}

export async function listarTipoListaChequeo({dispatch, state, rootState, commit}, id_empresa) {

    commit('dashboard/load', true, {root: true});

    let parametros = {
        params: {
            id_empresa: id_empresa
        }
    };

    await $http.get('adm_general/tipo-lista-chequeo', parametros)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setTipoListaChequeo', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

// filtro de paginacion
export function setPagePagination({commit, dispatch}, page) {
    commit('setPage', parseInt(page));
    dispatch('listarListasChequeo');
}
